

export default function Contact() {
  return (
    <div className="bg-gradient-to-b from-gray-50 to-white mx-10">
      <div className="w-full mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-4">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
            Contact Us
          </h1>
          <p className="text-xl md:text-2xl font-medium text-blue-700">
            Let’s Connect Today!
          </p>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Unlock global success with <strong>eBhasha</strong>! Break language barriers, accelerate your business growth.
            Contact us today to discuss your needs. Email us, and we’ll get back to you promptly.
          </p>
        </div>

        {/* Offices Grid */}
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
          {/* Hyderabad Head Office */}
          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl transition-shadow duration-300">
            <div className="bg-blue-600 px-6 py-5 text-white">
              <h2 className="text-2xl font-semibold">
                Head Office – Hyderabad
              </h2>
            </div>
            <div className="p-6 md:p-8 space-y-6">
              <div className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  <svg className="h-7 w-7 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <div className="ml-4">
                  <p className="text-gray-700 leading-relaxed">
                    Vindhya C4, Second Floor,<br />
                    CIE, IIIT Hyderabad Campus,<br />
                    Gachibowli, Hyderabad-500032
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  <svg className="h-7 w-7 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <div className="ml-4 space-y-2">
                  <p className="text-gray-800 font-medium">
                    <a href="tel:+919966443729" className="hover:text-blue-700 transition">
                      +91-99664 43729
                    </a>
                  </p>
                  <p className="text-gray-800 font-medium">
                    <a href="tel:+919968036443" className="hover:text-blue-700 transition">
                      +91-99680 36443
                    </a>
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  <svg className="h-7 w-7 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <div className="ml-4 space-y-2">
                  <p>
                    <a href="mailto:info@ebhashasetu.com" className="text-blue-600 hover:underline font-medium">
                      info@ebhashasetu.com
                    </a>
                  </p>
                  <p>
                    <a href="mailto:ebhashasetu@gmail.com" className="text-blue-600 hover:underline font-medium">
                      ebhashasetu@gmail.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Delhi NCR Branch Office */}
          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl transition-shadow duration-300">
            <div className="bg-indigo-600 px-6 py-5 text-white">
              <h2 className="text-2xl font-semibold">
                Branch Office – Delhi NCR
              </h2>
            </div>
            <div className="p-6 md:p-8 space-y-6">
              <div className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  <svg className="h-7 w-7 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <div className="ml-4">
                  <p className="text-gray-700 leading-relaxed">
                    B 77-78, Sindhuja Building,<br />
                    2nd Floor, Sector-6,<br />
                    Noida, UP 201301, INDIA
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  <svg className="h-7 w-7 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <div className="ml-4 space-y-2">
                  <p className="text-gray-800 font-medium">
                    <a href="tel:+919966443729" className="hover:text-indigo-700 transition">
                      +91-99664 43729
                    </a>
                  </p>
                  <p className="text-gray-800 font-medium">
                    <a href="tel:+919968036443" className="hover:text-indigo-700 transition">
                      +91-99680 36443
                    </a>
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  <svg className="h-7 w-7 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <div className="ml-4 space-y-2">
                  <p>
                    <a href="mailto:info@ebhashasetu.com" className="text-indigo-600 hover:underline font-medium">
                      info@ebhashasetu.com
                    </a>
                  </p>
                  <p>
                    <a href="mailto:ebhashasetu@gmail.com" className="text-indigo-600 hover:underline font-medium">
                      ebhashasetu@gmail.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Final CTA */}
        <div className="mt-16 text-center">
          <p className="text-lg text-gray-700 mb-6">
            Prefer to reach out quickly? Just drop an email — our team typically responds within a few hours on business days.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="mailto:info@ebhashasetu.com"
              className="inline-flex items-center px-8 py-4 bg-blue-600 text-white rounded-lg text-lg font-medium hover:bg-blue-700 transition shadow-md"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              Email Us Now
            </a>
          </div>
        </div>
      </div>
   
      {/* Dark mode ready text */}
      {/* <p className="text-text-primary-light dark:text-text-primary-dark">
        Hello Zahid
      </p>

      <button className="bg-primary-500 hover:bg-primary-600 text-white px-6 py-3 rounded-xl shadow-md hover:shadow-glow-primary transition-all duration-300">
        Get Started
      </button>

      <div className="bg-surface-light dark:bg-background-dark dark:text-text-primary-dark rounded-2xl shadow-lg p-6 border border-border-light dark:border-border-dark">
        Content
      </div>

      <h1 className="font-heading text-4xl md:text-5xl font-bold tracking-tight">
        MdZaar
      </h1> */}
    
    </div>
  );
}